import classNames from 'classnames';
import { useState } from 'react';
import { t } from 'ttag';

import { Stars } from '@ui/Stars';
import { SellerRatingModal } from '@components/SellerRatingModal';
import { rupluralize } from '@utils/i18n';

import s from './SellerRatingAverage.sss';

// types
type SellerRatingAverageProps = {
  overallRating: string | number;
  reviewsCount?: number | null
  className?: string;
  sellerId: number;
};

export const SellerRatingAverage: React.FC<SellerRatingAverageProps> = ({
  overallRating,
  reviewsCount,
  className,
  sellerId,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  let reviewsCountText;
  if (typeof reviewsCount === 'number') {
    const pluralized = rupluralize(reviewsCount, [t`оцінка`, t`оцінки`, t`оцінок`]);
    reviewsCountText = `(${reviewsCount} ${pluralized})`;
  }
  return (
    <>
      <div
        className={
          classNames(
            s.root,
            { [s.noReviews]: reviewsCount === 0 },
            className,
          )
        }
        onClick={reviewsCount !== 0 ? () => setIsOpenModal(true) : undefined}
      >
        <Stars
          value={+overallRating}
          readOnly={true}
          gap={4}
        />
        <div className={s.averageRating}>
          {overallRating}
          {
            reviewsCountText
              ? ` ${reviewsCountText}`
              : undefined
          }
        </div>
      </div>
      <SellerRatingModal
        sellerId={sellerId}
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
      />
    </>
  );
};
